module.exports = __webpack_public_path__ + "static/media/rowimg4.7bbc56a2.jpg";